export default __webpack_public_path__ + "src/images/about/Valuations-f47d12df3bb370b5299813f20f7cfefb.png";